/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 9/29/13
 * Time: 5:28 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var GoogleAnalyticsProfileModel = require("manager-components/google-analytics/models/GoogleAnalyticsProfileModel");
    var BaseCollection = require("collections/BaseCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var GoogleAnalyticsProfilesCollection = BaseCollection.extend({
        model: GoogleAnalyticsProfileModel,
        resource: ApiResources.AnalyticsDataSources.googleAnalyticsProfiles
    });

    return GoogleAnalyticsProfilesCollection;
});
